module.exports = __webpack_public_path__ + "img/apple_martini.f5b53914.jpg";